/* import __COLOCATED_TEMPLATE__ from './errors.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';

interface ErrorsFigureArgs {
  errors: { id: string; parameters: Parameters }[];
  resultErrors: { id: string; parameters: Parameters }[];
}

type Parameters = {
  [key in 'minimum' | 'maximum' | 'value' | 'unit']: string;
};

export default class ErrorsFigure extends Component<ErrorsFigureArgs> {
  @service declare intl: IntlService;

  get errorMessages(): string[] {
    return !this.args.errors
      ? []
      : this.args.errors.map((error) => {
          return this.intl.t(`figures.errors.${error.id}`, error.parameters);
        });
  }
  get resultErrorMessages(): string[] {
    return !this.args.resultErrors
      ? []
      : this.args.resultErrors.map((error) => {
          return this.intl.t(`figures.errors.${error.id}`, error.parameters);
        });
  }
}
